import { TEST_NET_ID } from "@/types/enum";

export interface IChainSupport {
  chainId: number;
}

export const SUPPORTED_CHAINS = [
  { name: "Base", id: TEST_NET_ID.BASE },
  { name: "Arbitrum", id: TEST_NET_ID.ARBITRUM },
  { name: "Polygon", id: TEST_NET_ID.POLYGON },
];

export default function chainSupport({ chainId }: IChainSupport) {

  const isSupported = SUPPORTED_CHAINS.some(chain => chain.id === chainId);

  if (!isSupported) {
    console.warn(`Chain ID ${chainId} is not supported.`);
    return false;
  }

  return true;
}
